import React, { useState, useEffect, useContext, useRef } from 'react'
import StockInHeader from './StockInHeader'
import StockInInner from './StockInInner'
import StockInFooter from './StockInFooter'
import { appContext } from '../../../App'
import { dateYMD, isObjEmpty } from '../../utilities/utilities'
import { deleteStockIn, getStockInList, saveStockIn, getProductsList, getWarehouses } from '../StockInFunctions'

export const stockInControllerContext = React.createContext()

function useStockInController(props) {
  const app = useContext(appContext)
  const initStockIn = {
    status: 'On Process',
    warehouse: { name: '',  id: null },
    date_received: dateYMD(new Date(app.getClientDateTime())),
    received_by: '',
    reference_code: '',
    supplier_name: '',
    remarks: '',
    item_details: []
  }
  const initStockInItemDetail = {
    id: '',
    name: '',
    unit: '',
    quantity: 1,
    fob: 0.00,
    total: 0.00,
    remarks: '',
    expiration_date: ''
  }
  const [stockIn, setStockIn] = useState(null)
  const [stockInItemDetail, setStockInItemDetail] = useState(initStockInItemDetail)
  const [stockInList, setStockInList] = useState([])
  const [productsList, setProductsList] = useState([])
  const [warehouses, setWarehouses] = useState(null)
  const [summary, setSummary] = useState(null)
  const refStockIn = useRef(null)

  const resetStockInItemDetail = () => setStockInItemDetail(initStockInItemDetail)

  useEffect(() => {
    const init = async () => {
      const stockin_list = await getStockInList(app)
      setStockInList(stockin_list)

      const products_list = await getProductsList(app)
      setProductsList(products_list.map(item => (
        {
          item_id: item._id,
          item_units: item.units,
          item_full_description: `${item.brand} ${item.name} ${item.description}`
        }
      )))

      const warehouse_list = await getWarehouses(app)
      setWarehouses(warehouse_list)

      const si = (
        isObjEmpty(props)
        ? {
            ...initStockIn,
            warehouse: { name: warehouse_list[0].name, id: warehouse_list[0]._id }
          }
        : props.stockInItem
      )

      setStockIn({
        ...si,
        status: 'On Process',
        warehouse: si.warehouse.name ? si.warehouse : { name: warehouse_list[0].name, id: warehouse_list[0]._id },
        date_received: dateYMD(new Date(si.date_received))
      })
    }

    init()

    // Unmounting
    return (async () => {
      const stock_in = refStockIn.current
      if (stock_in.status === 'On Process') {
        if (stock_in.item_details.length > 0) {
          stock_in.status = 'Unposted'
          await saveStockIn(app, stock_in)
        }
        else await deleteStockIn(app, stock_in._id)
      }
    })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const autoSaveStockIn = async () => {
      const computeSummaryTotal = () => {
        // Compute summary/total
        if (stockIn.item_details.length) {
          // Total total
          const totalTotal = stockIn.item_details
          .map(id => id.total)
          .reduce((prevTotal, curTotal) => (prevTotal + curTotal))

          setSummary({ totalTotal })
        } else { setSummary(null) }
      }

      // Auto-save stockIn here
      if (stockIn._id) {
        if (stockIn.new) return delete stockIn.new
        else {
          computeSummaryTotal()
          refStockIn.current = stockIn;
          await saveStockIn(app, stockIn, true);
        }
      } else { // It's a new Stockin
        computeSummaryTotal()
        const stock_in = await saveStockIn(app, stockIn)
        refStockIn.current = stock_in
        stock_in.new = true
        stock_in.date_received = dateYMD(new Date(stock_in.date_received))
        setStockIn(stock_in)
      }
    }

    if (stockIn) autoSaveStockIn()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockIn])

  const obj = {
    stockIn: [stockIn, setStockIn],
    stockInItemDetail: [stockInItemDetail, setStockInItemDetail, resetStockInItemDetail],
    saveStockIn, deleteStockIn, stockInList, productsList, warehouses, summary
 }
  return (obj)
}

function StockInController(props) {
  const stockInController = useStockInController(props)
  if (stockInController.stockIn[0])
    return (
      <React.Fragment>
        <stockInControllerContext.Provider value={stockInController}>
          <StockInHeader />
          <StockInInner />
          <StockInFooter />
        </stockInControllerContext.Provider>
      </React.Fragment>
    )
  return null
}

export default React.memo(StockInController)